module.exports = __webpack_public_path__ + "img/logo-youtube.edad0130.svg";